export const REGISTRATION_URL = 'https://forms.gle/KiCjGWVzsSnzP77JA';
export const POPE_URL = 'http://popesprayerusa.net/popes-intentions/';
export const BO_HOA_THIENG_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSejjX98GK4aX2iBGQMELQTBSYrH-au_IDY8TSUEp-7bd23UVg/viewform';